import {graphql, useStaticQuery} from 'gatsby';

type Partner = {
	data: {
		page: string
		slug: string
		partner: {
			data: {
				key: string
			}
		}[]
	}
}

const query = graphql`
query {
	partners: allAirtable(
		filter: {
			table: {eq: "Pages"}
			queryName: {eq: "PartnerPages"}
		}
	) {
		nodes {
			data {
				page: ID
				slug: Location_Slug
				partner: Partner {
					data {
						key: Secret_Key
					}
				}
			}
		}
	}
}`;

export const usePartner = (id: string): Partner => {
	const data = useStaticQuery(query);

	for (const partner of data.partners.nodes) {
		if (partner.data.page === id) {
			return partner;
		}
	}

	return {
		data: {
			page: '',
			slug: '',
			partner: []
		}
	};
};
